export const leftMenu = {
  profiles: {
    key: "profiles",
    label: "Profiles",
    subs: [
      { key: "profiles-port", label: "Port", showArrow: true },
      { key: "profiles-mac-address", label: "MAC Address ", showArrow: true },
      { key: "profiles-radius-server", label: "Radius Server ", showArrow: true },
    ],
    subKey: {
      port: "profiles-port",
      "mac-address": "profiles-mac-address",
      "radius-server": "profiles-radius-server",
    },
    getSubKey: (key) => {
      return leftMenu.profiles.subs.find((sub) => sub.key === key).key;
    },
  },
};